<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
  </div>
</template>

<script>
export default {
  name: "App",
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mounted() {
    if (this._isMobile()) {
      //跳转到手机端路由并设置rem
      this.$router.replace("/mHeader");
      (function(n, e) {
        var t = n.documentElement,
          i = "orientationchange" in window ? "orientationchange" : "resize",
          d = function() {
            var n = t.clientWidth;
            n && (t.style.fontSize = n / 7.5 + "px");
          };
        n.addEventListener &&
          (e.addEventListener(i, d, !1),
          n.addEventListener("DOMContentLoaded", d, !1));
      })(document, window);
    }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function(){
        this.isRouterAlive = true
      })
    },
    //判断用户设备
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    }
  }
};
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
div {
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
a {
  text-decoration: none;
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}
.el-menu--horizontal > .el-submenu .el-submenu__title {
  height: 50px !important;
}
.el-carousel__indicators {
  margin-bottom: 55px !important;
}
.el-carousel__indicator .el-carousel__button {
  height: 6px;
  width: 25px;
  border-radius: 5px;
}
.el-carousel__indicators .is-active .el-carousel__button {
  width: 42px;
}
.el-table__body {
  /* 使表格兼容safari，不错位 */
  width: 100%;
  table-layout: fixed !important;
}
#app {
  height: 100%;
}
/* 清除浮动 */
.clearfix:before,
.clearfix:after {
  content: "";
  display: table; /* 这句话可以出发BFC BFC可以清除浮动,BFC我们后面讲 */
}
.clearfix:after {
  clear: both;
}
.clearfix {
  *zoom: 1;
}
/* 修改移动端ue样式 */
.ue-content {
  font-size: 0.28rem !important;
}
/* 内容 */
.ue-content p {
  font-size: 0.28rem !important;
}
/* 标题 */
.ue-content p span {
  font-size: 0.32rem !important;
}
.timestart .el-input__inner {
  width: 1.6rem !important;
  height: 0.42rem !important;
  padding: 0.1rem !important;
  line-height: 0.42rem !important;
  font-size: 0.18rem !important;
  color: #b2b2b2 !important;
}
.timeend .el-input__inner {
  width: 1.6rem !important;
  height: 0.42rem !important;
  line-height: 0.42rem !important;
  font-size: 0.18rem !important;
  padding: 0.1rem !important;
  color: #b2b2b2 !important;
}
.el-pager li.active {
  color: #76c3a2 !important;
}
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus,
.el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal > .el-submenu .el-submenu__title:hover,
.el-menu--horizontal .el-menu .el-menu-item,
.el-menu--popup {
  background-color: transparent !important;
}
.el-menu--popup {
  min-width: 120px !important;
}
.el-submenu__title i {
  color: white !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue